import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, NavController } from '@ionic/angular';
import { EventProvider } from '../../../../../../../providers/event/event';
import { SessionProvider } from '../../../../../../../providers/session/session';
import { EventCreateTabsPage } from '../../../../../../event/create/event-create-tabs/event-create-tabs';
import { activities, ITeam, LineUpService, TshirtStyle } from '../../../../../lineup/services/lineup-service';
import { TournamentService, IPlan, offlineUnloadKey$, PlanEnum } from '../../../../services/tournament.service';
import { SportAlgoUtils } from '../../../../services/sport.algo';
import { Router } from '@angular/router';

@Component({
  selector: 'me-ko',
  templateUrl: 'me-ko.html',
  styleUrls:['./me-ko.scss']
})
export class MeKoPage {
  plan = {
    id: new Date().getTime(),
    plantype: PlanEnum.MePage,
    eventId: 0,
    sporttype: 4,
    name: "",
    rounds: 1,
    days: 7,
    games: 18,
    teamNum: 8,
    groupNum: 2,
    groupSize: 4,
    roundPhase: false,
    teams: [],
    gameTable: [],
    roundTeams: [],
    roundGameTable: []
  };
  rounds = [];
  events = [];

  constructor(
    private gs: TournamentService,
    private router:Router,
    private ls: LineUpService,
    private navCtrl: NavController,
    private loader: LoadingController,
    private eventService: EventProvider,
    private sessionService: SessionProvider,
    private translate: TranslateService
  ) {
    this.getEvents();
  }

  getEvents() {
    this.eventService.getClientEvents().then(events => {
      this.events = events;
      if (events) this.plan.eventId = this.events[0].id;
    });
  }

  ionViewDidEnter() {
    this.plan.name = "Spielplan " + (this.gs.planList.length + 1);
  }

  save() {
    this.createTeams().then(async(teams) => {
      this.plan.teams = teams;
      this.setMatches();
      this.createEmptyGraph();
      let load = await this.loader.create({});
      load.present();
      this.gs.saveTou(this.plan).then(plan => {
        this.plan = plan;
        this.gs.planList.push(this.plan);
        this.gs.save();
        this.gs.$planListChangeSub.next(true);
        load.dismiss();
      });
      this.navigate();
    });
  }

  onAddEvent() {
    // this.app.getRootNav().getActiveChildNav().select(0);
    this.sessionService.getTokenAndNavigate(false, false).then(() => {
      // this.app.getRootNav().push(EventCreateTabsPage);
      this.navCtrl.navigateForward('/EventCreateTabsPage')
    });
  }

  filter(plan: any) {
    let obj = JSON.parse(JSON.stringify(plan));
    delete obj.gameTable;
    delete obj.roundTeams;
    delete obj.roundGameTable;
    delete obj.id;
    return obj;
  }

  async navigate() {
    let load = await this.loader.create({});
    load.present();
    // this.app.getRootNav().getActiveChildNav().select(0);
    this.navCtrl.navigateRoot('/tab1').then(() => {
      load.dismiss();
      this.navCtrl.navigateForward('/tab1');
      // this.app.getRootNav().getActiveChildNav().select(1);
    });
  }

  onGroupSizeChange() {
    this.plan.groupSize = Math.floor(this.plan.groupSize);
    this.plan.teamNum = Math.floor((this.plan.groupNum)) * Math.floor(this.plan.groupSize);
    this.plan.days = this.plan.games = Math.floor((this.plan.teamNum) - 1);
  }

  onGroupNumChange() {
    this.plan.groupNum = Math.floor(this.plan.groupNum);
    this.plan.teamNum = this.plan.groupNum * this.plan.groupSize;
    this.plan.days = this.plan.games = Math.floor((this.plan.teamNum) - 1);
  }

  onTeamNumChange() {
    this.plan.teamNum = Math.floor(this.plan.teamNum);
    this.plan.groupNum = this.plan.teamNum / this.plan.groupSize;
    this.plan.days = this.plan.games = Math.floor((this.plan.teamNum) - 1);
  }

  onGroupSizeChangeMan() {
    this.plan.groupSize = Math.floor(this.plan.groupSize);
  }

  onGroupNumChangeMan() {
    this.plan.groupNum = Math.floor(this.plan.groupNum);
  }

  onTeamNumChangeMan() {
    this.plan.teamNum = Math.floor(this.plan.teamNum);
  }

  getSportName() {
    return this.translate.instant(activities[this.plan.sporttype].path);
  }

  createTeams() {
    return new Promise<any>((resolve, reject) => {
      let gN = Number(this.plan.groupNum);
      let gS = Number(this.plan.groupSize);

      let ASCII = 65;
      let id = 0;
      for (let i = 0; i < gN; i++) {
        let group = [];
        for (let j = 0; j < gS; j++) {
          let team: ITeam = {
            id: new Date().getTime() + id,
            name: 'Team ' + String.fromCharCode(ASCII) + (j + 1),
            players: [],
            results: 0,
            points: 0,
            image: null,
            ord: id + 1
          };
          this.plan.teams.push(team);
          group.push(team);
          id += 1;
        }
        this.plan.roundTeams.push(group);
        ASCII += 1;
      }
      if (navigator.onLine) {
        this.gs.saveTeams(this.plan.teams).then(teams => resolve(teams));
      } else {
        localStorage.setItem(offlineUnloadKey$, "true");
        resolve(this.plan.teams);
      }
    });
  }

  createGameTable() {
    let n = Number(this.plan.teamNum);
    this.matchRecursive(SportAlgoUtils.squareCeil(n));

    let id = 0;
    for (let i = 0; i < this.rounds.length; i++) {
      let sum = 0;
      let pre = 0;
      let arr = [];
      for (let j = 0; j < this.rounds[i]; j += 2) {
        pre = this.rounds[i] * i;
        let gamePlan = {
          id: new Date().getTime() + id,
          type: this.plan.plantype,
          gameDay: i,
          name: this.plan.name,
          winner: -1,
          results: "0-0",
          points: "0-0",
          team1: {
            results: 0,
            points: 0,
            image: null,
            id: (i == 0) ? this.plan.teams[pre + j].id : -1,
            name: (i == 0) ? this.plan.teams[pre + j].name : "",
            players: []
          },
          team2: {
            results: 0,
            points: 0,
            image: null,
            id: (i == 0) ? this.plan.teams[pre + j + 1].id : -1,
            name: (i == 0) ? this.plan.teams[pre + j + 1].name : "",
            players: []
          }
        }
        arr.push(gamePlan);
        id += 1;
      }
      this.plan.gameTable.push(arr);
      sum += pre;
    }
  }

  matchRecursive(n: number): number {
    if (n <= 1) {
      return this.rounds.length;
    } else {
      this.rounds.push(n);
      return this.matchRecursive(n / 2);
    }
  }

  setMatches() {
    let gN = Number(this.plan.groupNum);
    let gS = Number(this.plan.groupSize);
    for (let r = 0; r < this.plan.rounds; r++) {
      let roundTable = [];
      for (let i = 0; i < gN; i++) {
        let table = SportAlgoUtils.createGamePlan(this.plan.teams.slice(i * gS, i * gS + gS), gS, this.plan, r);
        roundTable.push(table);
      }
      this.plan.gameTable.push(roundTable);
    }
  }


  createEmptyGraph() {
    let id = 0;
    this.rounds = [];
    this.matchRecursive(SportAlgoUtils.squareCeil(this.plan.teamNum));
    for (let i = 0; i < this.rounds.length; i++) {
      let sum = 0;
      let pre = 0;
      let arr = [];
      for (let j = 0; j < this.rounds[i]; j += 2) {
        pre = this.rounds[i] * i;
        let gamePlan = {
          id: new Date().getTime() + id,
          type: this.plan.plantype,
          gameDay: i,
          name: this.plan.name,
          results: "0-0",
          points: "0-0",
          time: "",
          date: "",
          winner: -1,
          played: false,
          mapping: true,
          team1: null,
          team2: null
        }
        arr.push(gamePlan);
        id += 2;
      }
      this.plan.roundGameTable.push(arr);
      sum += pre;
    }
  }


}




